<div
  class="shimmer"
  [ngClass]="animationDirection"
  [ngStyle]="{ width: width, height: height, 'border-radius': borderRadius }"
  [@shimmerAnimation]
></div>
